import LightSalesNav from '@/components/sales/LightSalesNav';
import LightHeroSection from '@/components/sales/LightHeroSection';
import HeroMediaSlideshow from '@/components/sales/HeroMediaSlideshow';
import LightProblemSection from '@/components/sales/LightProblemSection';
import LightSolutionSection from '@/components/sales/LightSolutionSection';
import LightTestimonialsSection from '@/components/sales/LightTestimonialsSection';
import LightPricingSection from '@/components/sales/LightPricingSection';
import LightFAQSection from '@/components/sales/LightFAQSection';
import LightSalesFooter from '@/components/sales/LightSalesFooter';
import LightExitPopup from '@/components/sales/LightExitPopup';
import MobileStickyBar from '@/components/sales/MobileStickyBar';
import SocialProofToast from '@/components/sales/SocialProofToast';
import CookieConsent from '@/components/CookieConsent';
import { Helmet } from 'react-helmet-async';

const Index = () => {
  return (
    <>
      <Helmet>
        <title>Faceless Aura Club – Build a Profitable Online Business Without Showing Your Face</title>
        <meta 
          name="description" 
          content="Learn AI-powered strategies to create sustainable passive income through faceless content, automated stores, and digital products. Join 1,200+ members. 7-day guarantee." 
        />
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
      </Helmet>
      
      <div className="min-h-screen bg-white">
        {/* Navigation */}
        <LightSalesNav />
        
        {/* Main sales funnel sections */}
        <main>
          <LightHeroSection />
          <HeroMediaSlideshow />
          <LightProblemSection />
          <LightSolutionSection />
          <LightTestimonialsSection />
          <LightPricingSection />
          <LightFAQSection />
        </main>

        {/* Footer */}
        <LightSalesFooter />

        {/* Mobile sticky CTA bar */}
        <MobileStickyBar />

        {/* Social proof toast notifications */}
        <SocialProofToast />

        {/* Exit intent popup */}
        <LightExitPopup />

        {/* Cookie consent banner */}
        <CookieConsent />
      </div>
    </>
  );
};

export default Index;
